import { Checkbox } from '@cian/ui-kit';

import * as React from 'react';

import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';

interface ISpecialOffersProps {
  isBlackFriday: boolean | null;
  isBlackFridayEnabled: boolean;
  isPromoEnabled: boolean;
  promo: boolean | null;
  onPromoChange(value: boolean | null): void;
  onBlackFridayChange(value: boolean | null): void;
}

export const SpecialOffers: React.FC<ISpecialOffersProps> = ({
  isBlackFriday,
  isBlackFridayEnabled,
  isPromoEnabled,
  promo,
  onBlackFridayChange,
  onPromoChange,
}) => {
  return (
    <Filter id="advancedFilter_specialOffers" label="Спецпредложения">
      <InlineFilterGroup>
        {isBlackFridayEnabled && (
          <InlineFilter>
            <Checkbox
              checked={!!isBlackFriday}
              label="Чёрная пятница"
              onChange={event => onBlackFridayChange(event.target.checked ? true : null)}
            />
          </InlineFilter>
        )}
        {isPromoEnabled && (
          <InlineFilter>
            <Checkbox
              checked={!!promo}
              label="Скидки и акции"
              onChange={event => onPromoChange(event.target.checked ? true : null)}
            />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </Filter>
  );
};
